'use client';

import { useRef } from 'react';

import { Link } from '@/components/atoms';
import { CookiesButton } from '@/components/molecules';
import { cn } from '@/lib/utils/tailwind';

import type { Page } from '@/lib/api/types';

export interface FooterLinksProps {
  pages: Page[];
}

export const FooterLinks = ({ pages }: FooterLinksProps) => {
  const contentRef = useRef<HTMLUListElement>(null);

  return (
    <ul
      ref={contentRef}
      className={cn(
        'px-(--horizontal-spacing-3)',
        'flex my-0 items-center gap-(--horizontal-spacing-6) flex-wrap',
      )}
    >
      <li className="whitespace-nowrap">
        <CookiesButton variant="link" />
      </li>
      {pages.map(page => {
        const slug = page.is_home ? '/' : `/${page.slug}`;
        return (
          <li key={`footer-link-${page.id}`} className="whitespace-nowrap">
            <Link href={slug} size="sm">
              {page.footer.name}
            </Link>
          </li>
        );
      })}
    </ul>
  );
};
